export enum InstitutionGroupType {
  Centralized = 1,
  Clustered = 6,
}
